import EventWebinarLayout from "./eventWebinarLayout";
import ThoughtLeadership from "./thoughtLeadership";

interface EmailLayoutProps {
  response: any;
  threadId: string;
  userId: string;
}

const EmailLayout = ({
  response,
  threadId,
  userId,
}: EmailLayoutProps) => {

  return (
    <>
     {
      response.template === "thought_leadership" ? (<ThoughtLeadership jsonData={response}/>) :   (<EventWebinarLayout jsonData={response.data} threadId={threadId} userId={userId}/>)
     }
    
    </>
  )
}

export default EmailLayout